import React, { useContext } from "react";
import SidebarMenu from "./SidebarMenu";
import { SidebarContext } from "../Layout";

const SideBarLayout = () => {
  const { collapsed, isMobile } = useContext(SidebarContext);
  
  // On mobile, always show expanded sidebar (with text)
  const isCollapsed = isMobile ? false : collapsed;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
      <SidebarMenu collapsed={isCollapsed} />
    </div>
  );
};

export default SideBarLayout;
